<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Estoques indisponíveis"
    >
        <rkm-form v-if="model">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        disabled
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.salasVacinacao"
                        disabled
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.salaVacinacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :value="inputVacinaValue"
                        disabled
                        label="Vacina"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-table
                        :fields="fields"
                        :items="model.saidas"
                    >
                        <template v-slot:cell(selecionado)="row">
                            <rkm-form-checkbox v-model="row.item.selecionado" />
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            return [
                { class: 'col-min', key: 'selecionado', label: '#' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'lote', label: 'Lote' },
                { key: 'dataValidadeLote', label: 'Validade do lote' },
                { key: 'motivoIndisponibilidade', label: 'Motivo' },
            ]
        },
        inputVacinaValue() {
            let value = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    value = this.model.vacinaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    value = this.model.vacinaSigla
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    value = this.model.vacinaSiglaNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    value = this.model.vacinaSiglaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.model.vacinaAbreviacaoNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.model.vacinaSiglaAbreviacaoNome
                    break;

                default:
                    value = this.model.vacinaNome
                    break;
            }

            return value
        },
    },
    created() {
        this.repositories = {
            baixa: this.getConectaSusRepository('imunizacao.baixa'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.load(item)
            this.$refs.RkmModal.show()
        },
        load(item) {
            const request = {
                tipoMovimentacao: 'indisponibilidade',
                salaVacinacaoId: item.salaVacinacaoId,
                vacinaId: item.vacinaId,
            }

            this.setLoading()

            this.repositories.baixa.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            const saidas = this.model.saidas.filter(estoqueIndisponivel => estoqueIndisponivel.selecionado === true)

            this.setLoading()

            const request = {
                tipoMovimentacao: 'indisponibilidade',
                saidas: saidas.map(saida => saida.id),
            }

            this.repositories.baixa.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.showSaveNotification()
                    this.handleExit()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {
            this.$emit('save')
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>